export * from './pipes/shared-pipes.module';
export * from './components';
export * from './modules';
export * from './guard/auth.guard';



// WEBPACK FOOTER //
// C:/Users/bishop.duperret.GOMURAL/Documents/ConciergeDashboard/gomural-mural-outlook-configuration-dashboard-43c2b5785cd3/src/app/shared/index.ts